import { useToastContext } from "components/alert/ToastContext";
import Base from "components/Base";
import BaseListagem from "components/BaseListagem";
import { useFilter } from "contexts/FilterContext";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import HelpdeskChamado from "model/helpdesk/HelpdeskChamado";
import HelpdeskTipoChamado from "model/helpdesk/HelpdeskTipoChamado";
import Pageable from "model/page/Pageable";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableStateEvent } from "primereact/datatable";
import { useEffect, useState } from "react";
import HelpdeskChamadoService from "service/helpdesk/HelpdeskChamadoService";
import { converterData } from "utils/convert";
import { dateRangeFilterTemplate, filterApplyTemplate, ListMatchModeOptions, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";
import HelpdeskGerarChamadoClienteModal from "./HelpdeskGerarChamadoClienteModal";
import { useNavigate } from "react-router";

const helpdeskChamadoService = new HelpdeskChamadoService();

export default function HelpdeskMeusChamadosListagem() {

    const navigate = useNavigate();
    const { msgAlerta, msgSucesso, msgErro } = useToastContext();
    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [rows, setRows] = useState<HelpdeskChamado[]>([]);
    const [pageable, setPageable] = useState(new Pageable(0, 10, "dataCriacao,DESC", 0));
    const [totalElements, setTotalElements] = useState<number>(0);
    const [clientes, setClientes] = useState<Pessoa[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [tiposChamado, setTiposChamado] = useState<HelpdeskTipoChamado[]>([]);
    const [gerarChamadoModal, setGerarChamadoModal] = useState<boolean>(false);

    const defaultFilters: DataTableFilterMeta = {
        status: {
            constraints: [
                {
                    value: ["AA", "AC"],
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        dataCriacao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        descricao: {
            constraints: [
                {
                    value: "",
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const filterContext = useFilter();
    const screen = "meusChamados";
    const [filters, setFilters] = useState<DataTableFilterMeta>(filterContext.filters[screen] ? filterContext.filters[screen] : defaultFilters);

    useEffect(() => {
        setFiltrando(true);
    }, []);

    useEffect(() => {
        setFiltrando(true);
    }, [filters]);

    useEffect(() => {
        helpdeskChamadoService.clientes().then((response) => {
            setClientes(response);
        }).catch((err) => {
            console.error(err);
        });
        helpdeskChamadoService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((err) => {
            console.error(err);
        });
        helpdeskChamadoService.tiposChamado().then((response) => {
            setTiposChamado(response);
        }).catch((err) => {
            console.error(err);
        });
    }, []);

    useEffect(() => {
        if (filtrando) {
            filterContext.updateFilters(screen, filters);
            helpdeskChamadoService
                .pesquisarCliente(pageable, filters)
                .then(lista => {
                    setFiltrando(false);
                    setRows(lista.content);
                    setTotalElements(lista.totalElements);
                })
                .catch(err => {
                    setFiltrando(false);
                });
        }
    }, [filtrando, pageable]);

    const onPage = (event: DataTableStateEvent) => {

        setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
        setFiltrando(true);

    };

    const recarregar = () => {
        window.location.reload();
    };

    const header = <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
        <div></div>
        <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Meus Contatos</span>

        <div style={{ display: "flex" }}>

            <Button
                style={{ marginRight: '5px' }}
                type="button"
                label="Criar Chamado"
                className="ui-button-info"
                icon="pi pi-plus"
                onClick={() => setGerarChamadoModal(true)}
            ></Button>
        </div>
    </div>

    return (
        <>
            <HelpdeskGerarChamadoClienteModal
                visible={gerarChamadoModal}
                setVisible={setGerarChamadoModal}
                onConfirm={() => {
                    recarregar();
                }}
            />
            <Base tituloPagina="Meus Chamados" >
                <DataTable
                    header={header}
                    value={rows} lazy dataKey="id" paginator
                    first={pageable.first} rows={10} totalRecords={totalElements} onPage={onPage}
                    loading={filtrando} tableStyle={{ minWidth: '75rem' }}
                    filters={filters} onFilter={(e) => setFilters(e.filters)}
                    emptyMessage="Nenhum registro encontrado"
                >
                    <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    body={(rowData) => (
                        <div style={{ maxWidth: '30rem', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                            {rowData.descricao}
                        </div>
                    )}
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                    <Column header="Data geração" body={(rowData: HelpdeskChamado) => converterData(rowData.dataCriacao)} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataCriacao"
                        filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }} />
                    <Column field="status" header="Status" body={(rowData) => helpdeskChamadoService.getStatus(rowData.status)}
                        filter showAddButton={false} showFilterOperator={false} filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterField="status"
                        filterElement={(options) => statusFilterTemplate(options, helpdeskChamadoService.getListaStatusFilter())} />
                    <Column header="" body={(rowData: HelpdeskChamado) => {
                        return <Button label="Bate Papo" onClick={() => {
                            navigate(`/helpdeskBatePapo/${rowData.id}`)
                        }} />
                    }} />
                </DataTable>
            </Base>
        </>
    )
}